import React, { createContext, useState, useEffect } from 'react';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updateProfile,
} from 'firebase/auth';
import { auth } from '../firebase';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Firebase keeps track of auth state automatically —
  // this listener fires on login, logout, and page refresh
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser); // null when logged out, user object when logged in
      setLoading(false);
    });

    // Cleanup listener on unmount
    return () => unsubscribe();
  }, []);

  const login = async (email, password) => {
    const result = await signInWithEmailAndPassword(auth, email, password);
    return result.user;
  };

  const signup = async (name, email, password) => {
    // 1. Create the account
    const result = await createUserWithEmailAndPassword(auth, email, password);
    // 2. Save the display name so user.displayName works everywhere
    await updateProfile(result.user, { displayName: name });
    // 3. Update local state immediately so UI reflects name right away
    setUser({ ...result.user, displayName: name });
    return result.user;
  };

  const logout = async () => {
    await signOut(auth);
    // onAuthStateChanged will automatically set user to null
  };

  return (
    <AuthContext.Provider value={{ user, login, signup, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
